import React, {useEffect, useState} from 'react';
import Typography from "@material-ui/core/Typography";

import ReunioesFilter from '../reunioesFilter';
import ReuniosCard from "../reunioesCard";
import UseStyle from "../useStyles";

const ReunioesList = (props) => {

  const { history } = props;

  const classes = UseStyle();

  const [proximasReunioes, setProximasReunioes] = useState([]);
  const [reunioesAnteriores, setReunioesAnteriores] = useState([]);

  const [atual, setAtual] = useState(0);
  const [quantidade, setQuantidade] = useState(6);  


  useEffect(() => {
  }, [])

  return (
    <>
      <div id="conteudo" style={{ width: '100%' }}>
        <ReunioesFilter setProximasReunioes={setProximasReunioes} setReunioesAnteriores={setReunioesAnteriores}/>
        <div style={{ padding: '0 24px', marginTop: 24,  }}>
          {proximasReunioes.length > 0 &&
            <div style={{position: 'relative'}}>
              <Typography className={classes.tituloAba}>Próximas reuniões</Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 24 }}>
                {proximasReunioes.map((item, key) => (
                  <ReuniosCard history={history} info={item} key={key} />
                ))}
              </div>
            </div> 
          }   
          {reunioesAnteriores.length > 0 &&
            <div style={{marginTop:24}}>
              <Typography className={classes.tituloAba}>Reuniões anteriores</Typography>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 24 }}>                
                {reunioesAnteriores.map((item, key) => (
                  <ReuniosCard antigo history={history} info={item} key={key} />
                ))}
              </div>
              {/* <Pagination pagina={0} totalDePaginas={1} onChangePage={() => console.log(1)}/> */}
            </div>
          }                 
        </div>
      </div>
    </>
  );
}

export default ReunioesList;
